import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { PopoverController } from '@ionic/angular';

@Component({
  selector: "hop-qr-code-modal",
  templateUrl: "hop-qr-code-modal.html",
  styleUrls: ['hop-qr-code-modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HopQRCodeModal {
  @Input() qrCodeData: string;
    
  constructor(
    public popoverCtrl: PopoverController,
    private readonly cd: ChangeDetectorRef,
  ) {
  }

  closePopover() {
    this.popoverCtrl.dismiss({ completedFlow: false });
  }

}
